import { FieldError } from 'react-hook-form';

export const errorFormatter = (name: string, error?: FieldError) => (error?.message ? `error-${name}` : name);
